import React, { useContext } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { UserGlobalContextMemorySpace } from "../../../contexts/user/userGlobalContext";
import classNames from "classnames";
import Tooltip from "@mui/material/Tooltip";
import { toSentenceCase } from "../../../utils/capitalize";

//ICONS
import preview from "../../../assets/img/card-icons/previsualizar.svg";
import download from "../../../assets/img/card-icons/descargar.svg";
import FileSave from "../../../assets/img/card-icons/file_save.svg";
import mail from "../../../assets/img/card-icons/mail.svg";
import share from "../../../assets/img/card-icons/compartir.svg";
import video from "../../../assets/img/card-icons/video.svg";
import videoDownload from "../../../assets/img/card-icons/descargar.svg";

export const TarjetaResultadosComponent = ({
  result,
  eventPreview,
  eventDownload,
  eventMail,
  eventShare,
  onVideoClick,
  videoGenerating = false,
  downloadingId = null,
}) => {

  const informeDisponible = result.links?.urlDownload && result.idReport !== "";
  const videoGenerable = result.videoStatus === "GenerateVideo";
  const videoCompleto = result.videoStatus === "VideoComplete";
  const videoAccionDisponible = videoGenerable || videoCompleto;

  return (
    <div
      className={"tarjeta--activa shadow mt-2"}
    >
      <div
        // className="d-flex justify-content-start align-items-center"        
        style={{display:"flex",flexDirection:"column",gap:"10px"}}
      >
        <div>
            <span className="resultado-etiqueta">Fecha:</span>
            <span className="resultado-valor">{result.dateDisplay}</span>
        </div>
        <div>
            <span className="resultado-etiqueta">Estudio:</span>
            <span className="resultado-valor">{toSentenceCase(result.description)}</span>
        </div>
        <div>
            <span className="resultado-etiqueta">Servicio:</span>
            <span className="resultado-valor">{result.service}</span>
        </div>
      </div>  
      <div class="separador" style={{width:"100%",borderTopWidth:"2px"}}></div>    
      <div className="iconos-acciones-tarjeta">

        {result.links?.urlViewer ? (
          <Tooltip
            title="Ver imágenes"
            placement="top"
            arrow
            enterTouchDelay={0}
            leaveTouchDelay={3000}
          >
          <span>
            <img
              src={preview}
              alt="Vista previa"
              className={result.links?.urlViewer ? "pointer" : "disabled-resultados"}
              onClick={() =>
                result.links?.urlViewer && eventPreview(result)
              }
            />
          </span>
        </Tooltip>
        ) : (
          <img
            src={preview}
            alt="Vista previa"
            className="disabled-resultados"
          />
        )}

        <Tooltip
          placement="top"
          arrow
          enterTouchDelay={0}
          leaveTouchDelay={3000}
          title={
            downloadingId === result.idLaboratory
              ? "Descargando"
              : informeDisponible ? (
              "Ver informe"
            ) : (
              <>
                <b>Ver informe</b>: será visible en el lapso normal de 7 a 10
                días según el tipo de estudio realizado.
              </>
            )
          }
        >
          <span>
            {downloadingId === result.idLaboratory ? (
              <span
                className="result-icon-spinner"
                role="status"
                aria-label="Descargando"
              />
            ) : (
              <img
                src={FileSave}
                alt="Descargar"
                className={informeDisponible ? "pointer" : "disabled-resultados"}
                onClick={() =>
                  informeDisponible && eventDownload(result)
                }
              />
            )}
          </span>
        </Tooltip>

        {result.links?.urlSendEmail ? (
          <Tooltip
            title="Enviar por E-mail"
            placement="top"
            arrow
            enterTouchDelay={0}
            leaveTouchDelay={3000}
          >
          <span>
            <img
              src={mail}
              alt="Email"
              className={result.links?.urlSendEmail ? "pointer" : "disabled-resultados"}
              onClick={() =>
                result.links?.urlSendEmail && eventMail(result)
              }
            />
          </span>
        </Tooltip>
        ) : (
          <img
            src={mail}
            alt="Email"
            className="disabled-resultados"
          />
        )}

        {videoAccionDisponible ? (
        <Tooltip
          placement="top"
          arrow
          enterTouchDelay={0}
          leaveTouchDelay={3000}
          title={videoGenerable ? "Generar video" : "Descargar video"}
        >
          <span>
            <img
              src={videoCompleto ? videoDownload : video}
              alt={videoGenerable ? "Generar video" : "Descargar video"}
              className={!videoGenerating ? "pointer" : "disabled"}
              onClick={() => onVideoClick?.(result)}
            />
          </span>
        </Tooltip>
        ) : (
          <img
            src={video}
            alt="Ver video"
            className="disabled"
          />
        )}
      </div>
    </div>
  );
};
